export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SET_MODAL_DATA = 'SET_MODAL_DATA';

export function hideModal() {
  return {
    type: HIDE_MODAL
  };
}

export function showModal() {
  return {
    type: SHOW_MODAL
  };
}

export function setModalData(missingArticles, fileUrl) {
  return {
    type: SET_MODAL_DATA,
    payload: {
      missingArticles,
      fileUrl
    }
  };
}



